import { useTranslate } from "hooks";
import React from "react";

export const FeatureUnavailable: React.FC = () => {
  const translate = useTranslate();
  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100">
      <h1 className="mb-3">{translate("FEATURE_UNAVAILABLE_TITLE")}</h1>
      <p className="text-muted">{translate("FEATURE_UNAVAILABLE_TEXT")}</p>
    </div>
  );
};
